import Repository from '@/libs/axios'

const resource = '/admin/api-keys'

export default {
  createApiKey(payload) {
    return Repository.post(resource, payload)
  },
  listApiKeys(params) {
    const query = params ? `?${new URLSearchParams(params).toString()}` : ''
    return Repository.get(`${resource}${query}`)
  },
  getApiKeyById(id) {
    return Repository.get(`${resource}/${id}`)
  },
  updateApiKey(id) {
    return Repository.put(`${resource}/${id}`)
  },
  testApiKey(id) {
    return Repository.post(`${resource}/${id}/test`)
  },
  getActiveApiKey() {
    return Repository.get(`${resource}/active`)
  },
  deleteApiKey(id) {
    return Repository.delete(`${resource}/${id}`)
  },
}
